


































































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

import CurrentHoldingsTable from "@/shared/components/investments/drivewealth/CurrentHoldingsTable.vue";
import CurrentHoldingsChart from "@/shared/components/investments/drivewealth/CurrentHoldingsChart.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useNotifierStore } from "@/shared/store/notifier";
import * as Routes from "@/employee/route-names";
import * as SharedRoutes from "@/shared/route-names";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { Permission, DrivewealthAccountSummary, DrivewealthAccountLiquidationStatus } from "@/shared/types";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";




@Component({
  components: {
    CurrentHoldingsTable,
    CurrentHoldingsChart,
    DrivewealthNavigation
  }
})
export default class DrivewealthAccountLiquidationPage extends Vue {
  drivewealthStore = useDrivewealthStore();
  rolePermissionsStore = useRolePermissionsStore();


  Routes = Routes;
  SharedRoutes = SharedRoutes;
  liquidateModal = false;


  @Prop() accountId: number;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: false })
  username: string;

  onClose () {
    this.liquidateModal = false;
  }

  openModal () {
    this.liquidateModal = true;
  }

  onLiquidate () {
    this.drivewealthStore.liquidateAccount(this.accountId, this.partnerId).then(result => {
      useNotifierStore().setSuccess("Account liquidation has been started");
      if (this.partnerId) {
        this.$router.replace({ name: SharedRoutes.DrivewealthInvestmentAccountV2,
          params: { accountId: `${this.accountId}`, partnerId: `${this.partnerId}` },
          query: (this.username) ? { username: this.username } : undefined });
      } else {
        this.$router.replace({ name: Routes.DrivewealthMultipleAccountSelection });
      }
    }).finally(() => {
      this.onClose();
    });
  }

  get showModal () {
    return this.liquidateModal;
  }

  get permissionToLiquidate () {
    return !this.partnerId || this.rolePermissionsStore.userHasPartnerPermission(Permission.InvestmentInstrumentAllowSell, this.partnerId);
  }

  get accountSummaryV2 (): DrivewealthAccountSummary {
    return this.drivewealthStore.accountSummaryById(this.accountId);
  }

  showLiquidateLink (dwAccount: DrivewealthAccountSummary) {
    return dwAccount.liquidationStatus === null ||
      dwAccount.liquidationStatus === DrivewealthAccountLiquidationStatus.NotStarted ||
      dwAccount.liquidationStatus === DrivewealthAccountLiquidationStatus.Failed;
  }

  liquidateText (account: DrivewealthAccountSummary) {
    if (account.liquidationStatus === DrivewealthAccountLiquidationStatus.Pending) {
      return "Liquidation In Progress";
    }
    else if (account.liquidationStatus === DrivewealthAccountLiquidationStatus.Completed) {
      return "Liquidation Complete";
    }
    else {
      return "Liquidate Assets";
    }
  }
}
